var map = {
	"./Favorites": 1129,
	"./Favorites.tsx": 1129,
	"./FavoritesDeferred": 366,
	"./FavoritesDeferred.tsx": 366,
	"./FavoritesPage": 365,
	"./FavoritesPage.dictionary": 339,
	"./FavoritesPage.dictionary.json": 339,
	"./FavoritesPage.explanation": 1130,
	"./FavoritesPage.explanation.ts": 1130,
	"./FavoritesPage.tsx": 365,
	"./actions": 98,
	"./actions/": 98,
	"./actions/index": 98,
	"./actions/index.ts": 98,
	"./components/Loader": 1017,
	"./components/Loader/": 1017,
	"./components/Loader/Loader": 966,
	"./components/Loader/Loader.dictionary": 920,
	"./components/Loader/Loader.dictionary.json": 920,
	"./components/Loader/Loader.explanation": 1131,
	"./components/Loader/Loader.explanation.ts": 1131,
	"./components/Loader/Loader.module.scss": 1030,
	"./components/Loader/Loader.tsx": 966,
	"./components/Loader/index": 1017,
	"./components/Loader/index.ts": 1017,
	"./components/NoData": 1018,
	"./components/NoData/": 1018,
	"./components/NoData/NoData": 967,
	"./components/NoData/NoData.dictionary": 923,
	"./components/NoData/NoData.dictionary.json": 923,
	"./components/NoData/NoData.explanation": 1132,
	"./components/NoData/NoData.explanation.ts": 1132,
	"./components/NoData/NoData.module.scss": 1031,
	"./components/NoData/NoData.tsx": 967,
	"./components/NoData/index": 1018,
	"./components/NoData/index.ts": 1018,
	"./components/NoDataSkeleton": 889,
	"./components/NoDataSkeleton/": 889,
	"./components/NoDataSkeleton/NoDataSkeleton": 871,
	"./components/NoDataSkeleton/NoDataSkeleton.module.scss": 921,
	"./components/NoDataSkeleton/NoDataSkeleton.tsx": 871,
	"./components/NoDataSkeleton/constants": 890,
	"./components/NoDataSkeleton/constants.ts": 890,
	"./components/NoDataSkeleton/index": 889,
	"./components/NoDataSkeleton/index.ts": 889,
	"./components/PopularMatches": 891,
	"./components/PopularMatches/": 891,
	"./components/PopularMatches/PopularMatches": 872,
	"./components/PopularMatches/PopularMatches.dictionary": 874,
	"./components/PopularMatches/PopularMatches.dictionary.json": 874,
	"./components/PopularMatches/PopularMatches.explanation": 1133,
	"./components/PopularMatches/PopularMatches.explanation.ts": 1133,
	"./components/PopularMatches/PopularMatches.module.scss": 922,
	"./components/PopularMatches/PopularMatches.tsx": 872,
	"./components/PopularMatches/index": 891,
	"./components/PopularMatches/index.ts": 891,
	"./components/SportGrid": 856,
	"./components/SportGrid/": 856,
	"./components/SportGrid/SportGrid": 840,
	"./components/SportGrid/SportGrid.module.scss": 873,
	"./components/SportGrid/SportGrid.tsx": 840,
	"./components/SportGrid/index": 856,
	"./components/SportGrid/index.ts": 856,
	"./components/TournamentTable": 841,
	"./components/TournamentTable/": 841,
	"./components/TournamentTable/TournamentTable": 834,
	"./components/TournamentTable/TournamentTable.ts": 834,
	"./components/TournamentTable/index": 841,
	"./components/TournamentTable/index.ts": 841,
	"./reducer": 296,
	"./reducer/": 296,
	"./reducer/entities": 351,
	"./reducer/entities.ts": 351,
	"./reducer/index": 296,
	"./reducer/index.js": 296,
	"./reducer/presentation": 352,
	"./reducer/presentation.ts": 352,
	"./selectors/gridEntities": 127,
	"./selectors/gridEntities.ts": 127,
	"./selectors/gridPresentation": 1077,
	"./selectors/gridPresentation.ts": 1077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 1262;
module.exports = webpackContext;